export default __webpack_public_path__ + "static/media/element_55.df09f18f.webp";